import { Link } from "wouter";

export default function TermsOfUse() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16 md:py-24">
      <article className="mx-auto max-w-4xl rounded-2xl bg-white px-6 py-10 shadow-sm ring-1 ring-slate-200 md:px-12 md:py-14">
        <Link href="/" className="text-sm font-semibold text-blue-700 hover:text-blue-900">
          Back to home
        </Link>
        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">Legal information</p>
        <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 md:text-5xl">Terms of Use</h1>
        <p className="mt-4 text-sm text-slate-500">Last updated: September 17, 2026</p>

        <div className="mt-10 space-y-8 text-base leading-8 text-slate-700">
          <section>
            <h2 className="text-2xl font-bold text-slate-950">Acceptance of these terms</h2>
            <p className="mt-3">
              By using IGETALIBAR, you agree to use this information and support platform responsibly and in accordance with these Terms of Use. If you do not agree, please do not use the site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Information-only service</h2>
            <p className="mt-3">
              This site provides general product information, educational guides, support resources, and public location-discovery information. Content is provided for information purposes and may not be complete, current, or suitable for every person. Check applicable Australian laws, age requirements, product availability, and retailer authorisation independently.
            </p>
            <p className="mt-3">
              IGETALIBAR does not sell products, accept orders, process payments, arrange delivery, or provide a guarantee of stock or retailer status through this site. Any authorised sales entry is a separate external service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Acceptable use</h2>
            <p className="mt-3">
              You must not misuse the site, interfere with its operation, attempt unauthorised access, introduce malicious code, scrape or overload services, impersonate another person, or use the site to violate any law or third-party right. You are responsible for the accuracy of information you choose to submit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">External links and public locations</h2>
            <p className="mt-3">
              The site may link to third-party websites and display public map information. IGETALIBAR does not control those services and does not guarantee their accuracy, availability, safety, authorisation status, inventory, opening hours, or suitability. Verify details directly with the relevant provider before relying on them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Intellectual property</h2>
            <p className="mt-3">
              Unless stated otherwise, the site structure, original text, interface, and software are protected by applicable intellectual-property laws. You may view and use the site for personal, lawful information purposes. Do not copy, republish, modify, or commercially exploit site materials without appropriate permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Disclaimers and liability</h2>
            <p className="mt-3">
              To the extent permitted by law, the site is provided on an “as available” basis without a guarantee that content will always be accurate, uninterrupted, or error-free. Nothing in these terms excludes, restricts, or modifies a consumer guarantee or other right that cannot lawfully be excluded under Australian law. To the extent permitted by law, you use the site at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Changes and contact</h2>
            <p className="mt-3">
              We may update these terms when the site or its services change. Continued use after an update means you accept the revised terms. For questions about these terms, use the available support channel or contact the site operator through the authorised support route.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
}
